// Seiten von Billtoro erst laden, wenn sie gebraucht werden (eigene Datei je Seite, React.lazy): Das Rechnungswerkzeug
// bindet sie fest ein (rechnung/RechnungTool.tsx), die Kanzlei-Instanz lädt ihren Inhalt so nie herunter.
// Ohne Rahmen.tsx (der lädt die Gestaltung der Seiten, seiten.css): die kommt mit der Seite.
import { lazy, Suspense, type ComponentType } from 'react';
import type { ShellSeite } from './types';

export function faul(laden: () => Promise<{ default: ComponentType<ShellSeite> }>): ComponentType<ShellSeite> {
  const Seite = lazy(laden);
  return function FaulSeite(p: ShellSeite) {
    return (
      <Suspense fallback={<div className="spinner" role="status" aria-label="Lädt" />}>
        <Seite {...p} />
      </Suspense>
    );
  };
}
